import React from 'react';

/**
 * ChevronIcon
 * Small downward chevron, used e.g. as the affordance on the speciality
 * dropdown trigger in the hero search bar. Purely decorative — hidden from
 * assistive technology via `aria-hidden` (no accessible label needed).
 */
const ChevronIcon: React.FC<{
  width?: number | string;
  height?: number | string;
  stroke?: string;
}> = ({ width = 10, height = 6, stroke = 'currentColor' }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 10 6"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="inline-block align-middle"
    aria-hidden="true"
  >
    <path
      d="M0.5 0.5L5 5.5L9.5 0.5"
      stroke={stroke}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default ChevronIcon;
